import VForm from '@/vuetify_custom/v-form'
import VModel from '@/vuetify_custom/v-modal_v1'
function createParams() {
    return {
        type:null
    }
}


export default {
    data() {
        this.source = null
        return {
            dis: false,
            submitLoading: false,
            params:createParams(),
            
        }
    },
    computed: {
        baseInforFields() {
            const d = [(val) => !!val || '必选']
            const arr = [
               {
                    label: '合同类型',
                    type: 'select_field',
                    key: 'type',
                    'item-text': 'label',
                    'item-value': 'value',
                    cols: 12,
                    required: true,
                    items:[
                        {
                            label: '普通合同',
                            value: 'Contract'
                        },
                        {
                            label: '兼职外包合同',
                            value: 'OutsourceContract'
                        },
                    ],
                    rules: d,
                },
            ]
            return arr
        },
    },
    methods: {
        cancel() {
            this.dis = false
            this.$emit('cancel')
        },
        edit(p, s) {
            this.source = s
            this.dis = true
            this.params = createParams()
            this.params.p = p
        },
        submit() {
            if (!(this.$refs.base && this.$refs.base.validate && this.$refs.base.validate())) {
                return
            }
            this.$emit('select', this.params.type, this.params.p)
            this.dis = false
        }
    },
    render() {
        return <VModel
        v-model={this.dis}
        persistent
        dynamic-height
        height-rate={0.4}
        title="提示"
        max-width="600"
        loading={this.submitLoading}
        on={{
             ok: this.submit,
            cancel: this.cancel
        }}
       
    >
        <VForm
            ref="base"
            v-model={this.params}
            fields={this.baseInforFields}
        />
        {/* attitude_rating */}
        </VModel>
    }
}